import { autocompleteClasses, Box, styled } from "@mui/material";

export const StyledContentBox = styled(Box)`
  display: inline-flex;
  flex-direction: column;
  margin: 10px;
  margin-top: 0px !important;
`;
